
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexpzvUERrqWfCfDC0XIwCcNF0Wxw7IgAfUNGE_45SoBdQwEMeta } from "/Volumes/4TB-PRO-BLADE/projects/mvpProject/website/mvp-website-new/pages/index.vue?macro=true";
import { default as thankyou_tAmvDPJAUl4rtghI34eFztTqroEfw8emmXdjXPzDJAMeta } from "/Volumes/4TB-PRO-BLADE/projects/mvpProject/website/mvp-website-new/pages/thankyou.vue?macro=true";
import { default as no_45interestMTe3zMpsBtWgYMngL4Z6jUL93ixO137BEL5AD4EoDAMMeta } from "/Volumes/4TB-PRO-BLADE/projects/mvpProject/website/mvp-website-new/pages/no-interest.vue?macro=true";
import { default as privacy_45policyi1Ut9csxlSgfSbcjn7BHULbFWJdlFi1ly3lZnQnwYXkMeta } from "/Volumes/4TB-PRO-BLADE/projects/mvpProject/website/mvp-website-new/pages/privacy-policy.vue?macro=true";
import { default as thankyou_45realtorGAQsyiDzCoe7AKkNvrqwpyg3qi67N4N8m_45MMmKHT6gUMeta } from "/Volumes/4TB-PRO-BLADE/projects/mvpProject/website/mvp-website-new/pages/thankyou-realtor.vue?macro=true";
import { default as thankyou_45for_45respondingNnp_Uo13_45u7YgORvY5r1Yz7qCJXGE6en6NnrmE09YvQMeta } from "/Volumes/4TB-PRO-BLADE/projects/mvpProject/website/mvp-website-new/pages/thankyou-for-responding.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/Volumes/4TB-PRO-BLADE/projects/mvpProject/website/mvp-website-new/pages/index.vue")
  },
  {
    name: "thankyou",
    path: "/thankyou",
    component: () => import("/Volumes/4TB-PRO-BLADE/projects/mvpProject/website/mvp-website-new/pages/thankyou.vue")
  },
  {
    name: "no-interest",
    path: "/no-interest",
    component: () => import("/Volumes/4TB-PRO-BLADE/projects/mvpProject/website/mvp-website-new/pages/no-interest.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/Volumes/4TB-PRO-BLADE/projects/mvpProject/website/mvp-website-new/pages/privacy-policy.vue")
  },
  {
    name: "thankyou-realtor",
    path: "/thankyou-realtor",
    component: () => import("/Volumes/4TB-PRO-BLADE/projects/mvpProject/website/mvp-website-new/pages/thankyou-realtor.vue")
  },
  {
    name: "thankyou-for-responding",
    path: "/thankyou-for-responding",
    component: () => import("/Volumes/4TB-PRO-BLADE/projects/mvpProject/website/mvp-website-new/pages/thankyou-for-responding.vue")
  }
]